import { render, staticRenderFns } from "./SMSDialog.vue?vue&type=template&id=519b6290"
import script from "./SMSDialog.vue?vue&type=script&lang=js"
export * from "./SMSDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports